import { Typography } from "@mui/material";
import classNames from "classnames";
import { FaCheck } from "react-icons/fa6";
import { Link } from "react-router-dom";

import { lessonType } from "../../../../constants";
import { useMyCourseInstructor } from "../hooks/useMyCourseInstructor";

export function LeftMenu() {
	const {
		course,
		courseDocuments,
		lessons,
		learningSummaries,
		upcomingSummaries,
	} = useMyCourseInstructor();

	if (!course) {
		return null;
	}

	const path = location.pathname.split("/").reverse()[0];
	const descriptionWarning =
		course.description.trim() === "" || courseDocuments.length === 0;
	const classesWarning =
		lessons.length === 0 ||
		lessons.some(
			(lesson) =>
				lesson.description.trim() === "" ||
				Number(lesson.totalCost) === 0 ||
				(lesson.type === lessonType.ONSITE &&
					Number(lesson.flightTime) + Number(lesson.teachingTime) === 0),
		);
	const logisticsWarning = false;

	return (
		<div className="left-menu-container">
			<div>
				<Typography className="big-text bold">My Service</Typography>
				<div className="item-separator-small" />
				<Link
					to={`/my-services/${course.courseSlug}/description`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "description",
						})}>
						<div className="circle">
							{!descriptionWarning && <FaCheck className="check-icon" />}
						</div>
						<Typography
							className={classNames("normal-text", {
								bold: path === "description",
							})}>
							Description
						</Typography>
					</div>
				</Link>
				<Link
					to={`/my-services/${course.courseSlug}/classes`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "classes",
						})}>
						<div className="circle">
							{!classesWarning && <FaCheck className="check-icon" />}
						</div>
						<Typography
							className={classNames("normal-text", {
								bold: path === "classes",
							})}>
							Classes
						</Typography>
					</div>
				</Link>
				<Link
					to={`/my-services/${course.courseSlug}/logistics`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "logistics",
						})}>
						<div className="circle">
							{!logisticsWarning && <FaCheck className="check-icon" />}
						</div>
						<Typography
							className={classNames("normal-text", {
								bold: path === "logistics",
							})}>
							Logistics
						</Typography>
					</div>
				</Link>
			</div>
			<div>
				<Typography className="big-text bold">Visibility</Typography>
				<div className="item-separator-small" />
				<Link
					to={`/my-services/${course.courseSlug}/publishing`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "publishing",
						})}>
						<Typography
							className={classNames("normal-text", {
								bold: path === "publishing",
							})}>
							Publishing
						</Typography>
					</div>
				</Link>
				<Link
					to={`/my-services/${course.courseSlug}/remove`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "remove",
						})}>
						<Typography
							className={classNames("normal-text", {
								bold: path === "remove",
							})}>
							Remove
						</Typography>
					</div>
				</Link>
			</div>
			<div>
				<Typography className="big-text bold">Track</Typography>
				<div className="item-separator-small" />
				<Link
					to={`/my-services/${course.courseSlug}/students`}
					className="black-text no-underline-link">
					<div
						className={classNames("left-menu-item", {
							selected: path === "students",
						})}>
						<Typography
							className={classNames("normal-text", {
								bold: path === "students",
							})}>
							{`Students (${learningSummaries.length + upcomingSummaries.length})`}
						</Typography>
					</div>
				</Link>
			</div>
		</div>
	);
}
